// extracted by mini-css-extract-plugin
export default {"content":"styles_content__mZoPu","button":"styles_button__XH2VS"};